<template>
  <a-entity :position="inlinePosition(defaultPos)" ref="camera_pivot">
    <a-entity ref="vr_fix">
      <a-entity
        class="Camera"
        position="0 0 0"
        ref="camera"
        @loaded="loaded"
        :camera="inlineObject(settings.camera)"
        :look-controls="inlineObject(settings.lookControls)"
        >
        <a-entity ref="layer" class="Camera__layer" position="0 0 -1">
          <Load v-if="$route.meta.name == 'load'" />
          <Explorer v-if="$route.meta.name == 'explorer' && !viewed.explorer" />
          <Tooltip v-if="$route.meta.name == 'captation' && !$route.params.captation && !viewed.tooltip" />
          <a-plane
            ref="conclusion"
            :scale="$route.meta.name == 'conclusion' ? '1 1 1' : '0 0 0'"
            color="#fff"
            material="shader: flat"
            width="8" height="8"
            opacity="0"
            position="0 0 -.1"
          />
          <Infos v-if="$route.meta.name == 'infos'" />
          <Music ref="music" v-if="cameraLoaded" />
          <CursorComp />
          <transition @leave="hideStartVrBg">
            <a-plane
              ref="vrstart_bg"
              v-if="$route.meta.name == 'vrstart'"
              opacity="0" transparent="true"
              @loaded="showStartVrBg"
              material="shader: flat" color="#fc1f1f" width="8" height="8" position="0 0 .1" />
          </transition>
        </a-entity>
      </a-entity>
    </a-entity>

    <TitleLevel
      v-for="n in 7"
      :key="n"
      :index="n"
      v-if="$route.meta.name == 'level' && $route.params.level == n"
    />
    <VrStart v-if="$route.meta.name == 'vrstart'" />
    <Wait v-if="$route.meta.name == 'wait'" />
    <BottomVr />

  </a-entity>
</template>

<script>
import Settings from '@/config/Settings'
import Music from '@/components/music/Music.vue'
import Load from '@/components/load/Load.vue'
import Tooltip from '@/components/tooltip/Tooltip'
import Explorer from '@/components/explorer/Explorer'
import Infos from '@/components/infos/Infos'
import CursorComp from '@/components/cursor/Cursor'
import TitleLevel from '@/components/title-level/TitleLevel'
import Wait from '@/components/wait/Wait'
import BottomVr from '@/components/bottom-vr/BottomVr'
import VrStart from '@/components/vr-start/VrStart'

export default {
  name: 'Camera',
  components: { Load, Music, Tooltip, Explorer, CursorComp, Infos, TitleLevel, Wait, BottomVr, VrStart },
  data: () => ({
    defaultPos: { x: 1.2, y: 2, z: 6.6 },
    cameraLoaded: false,
    settings: {
      camera: {
        fov: 50,
      },
      lookControls: {
        enabled: true,
        reverseMouseDrag: true
      }
    },
    viewed: {
      explorer: false,
      tooltip: false
    },
  }),
  watch: {
    '$route': 'checkRoute',
    isPlaying() {
      if(!this.$tween) return

      this.isPlaying
      ? this.$tween.play()
      : this.$tween.pause()
    },
    orientation() {
      this.setFov()
    },
  },
  beforeDestroy() {
    if(this.$rafId) {
      cancelAnimationFrame(this.$rafId)
    }
  },
  created() {
    this.setFov()
  },
  methods: {
    showStartVrBg() {
      TweenLite.to(this.$refs.vrstart_bg, 1, { aframe: { alpha: 1 }})
    },
    hideStartVrBg(el, done) {
      TweenLite.to(this.$refs.vrstart_bg, 5, { aframe: { alpha: 0 }, onComplete: done})
    },
    setFov() {
      this.settings.camera.fov = this.orientation == 'landscape' && this.$root.$agent.mobile ? 30 : 50
    },
    loaded() {
      this.cameraLoaded = true
      this.$lookControls = this.$refs.camera.components['look-controls']
      this.$observer = this.$parent.$refs.observer.object3D
      this.$obelix = this.$parent.$refs.obelix.object3D.position
      this.$house = this.$parent.$refs.house.object3D.position

      setTimeout(() => {
        this.$nextTick(() => this.checkRoute())
      }, 0)
    },
    checkRoute() {
      const routeName = this.$route.meta.name
      const captation = this.$route.params.captation
      const level = this.$route.params.level
      const timeCaptionInOut = 20
      const ease = Quad.easeInOut

      if(this.$tween)
        this.$tween.kill()

      this.settings.lookControls.enabled = true

      if(routeName == 'load') {
        if(!this.vr && !this.$root.$agent.mobile)
          TweenLite.to(this.$refs.camera.object3D.rotation, .5, { x: 0,
            onStart: () => this.settings.lookControls.enabled = false,
            onComplete: () => {
              this.$lookControls.pitchObject.rotation.x = 0
              this.settings.lookControls.enabled = true
            }
          })
      }

      if(routeName == 'load' || routeName == 'infos' || routeName == 'vrstart') {
        TweenLite.set(this.$el, { aframe: { x: 5, y: 8, z: 20 } })

        TweenLite.set(this.$el.object3D.rotation, {
          directionalRotation: { y: () => {
            const pos = this.fixObject({ x: 0, y: 0, z: -50 })
            return pos + '_short'
          }, useRadians: true },
        })
      }

      if(routeName == 'infos')
        this.$tween = TweenLite.to(this.$el, 18, { aframe: { x: 0, y: 2, z: 10 }})

      if(routeName == 'wait' || routeName == 'start')
        TweenLite.set(this.$el, { aframe : { x: 0, y: 2, z: 10 }})

      if(routeName == 'start') {
        this.$tween = new TimelineLite()
        .to(this.$el, 15, { aframe: { x: 0, y: 2, z: -6.5 }, ease: ease})
        if(!this.vr) {
          this.$tween.to(this.$el.object3D.rotation, 3, {
            directionalRotation: { y: () => {
              const pos = this.fixObject(this.$obelix)
              return pos + '_short'
            }, useRadians: true },
          })
        }
        this.$tween
        .to({}, this.vr ? 8 : 5, {})
        if(!this.vr) {
          this.$tween.to(this.$el.object3D.rotation, 5, { directionalRotation: { y: () => {
            const pos = this.fixObject(this.$house)
            return pos + '_short'
          }, useRadians: true }})
        }
        const retourPos = this.vr ? 0 : 5
        this.$tween.to(this.$el, 12, { aframe: { ...this.defaultPos }, ease: ease }, '-=' + retourPos)
      }

      if(routeName == 'level')
        this.$tween = TweenLite.to(this.$el, timeCaptionInOut, { aframe: { ...this.defaultPos }, ease: ease})

      if(routeName == 'captation' && !captation || routeName == 'explorer') {
        this.$tween = new TimelineLite()
        if(routeName == 'captation' && !captation){
          const captationSuggested = _.find(this.captations, c => c.is_focus[this.lang] && c.level == level)
          const suggestedDirection = captationSuggested ? _.clone(captationSuggested.position) : null
          if(suggestedDirection && !this.vr)
            this.$tween.to(this.$el.object3D.rotation, 3, {
              delay: .2,
              directionalRotation: {
                y: () => (this.fixObject(suggestedDirection)) + '_short',
                useRadians: true
              }
            })
        }
        this.$tween.to(this.$el, timeCaptionInOut, { aframe: { ...this.defaultPos  }, ease: ease})
      }

      if(routeName == 'captation' && captation) {
        const captationPos = _.clone(_.find(this.captations, c => c.name == captation).position)
        const direction = new THREE.Vector3()
        const p = new THREE.Vector3()
        direction.subVectors(this.$el.object3D.position, captationPos).normalize()
        const multiplyScalar = this.$root.$agent.mobile && !this.vr ? 4 : 2.5
        p.addVectors(captationPos, direction.multiplyScalar(multiplyScalar))

        const y = this.fixObject(captationPos)

        // console.log(p.distanceTo(this.$el.object3D.position))

        this.$tween = new TimelineLite()
          if(!this.vr)
            this.$tween.to(this.$el.object3D.rotation, 1.5, { directionalRotation: { y: y + '_short', useRadians: true }})

          if(!this.vr && !this.$root.$agent.mobile)
            this.$tween.to(this.$refs.camera.object3D.rotation, 1, { x: 0,
              onStart: () => this.settings.lookControls.enabled = false,
              onComplete: () => {
                this.$lookControls.pitchObject.rotation.x = 0
                this.settings.lookControls.enabled = true
              }
            }, '-=1.5')

          this.$tween.to(this.$el, timeCaptionInOut, { aframe: { x: p.x, z: p.z, y: this.defaultPos.y }, ease: ease})
      }

      if(routeName == 'conclusion')
        this.pathConclusion()
    },
    pathConclusion() {
      this.$tween = new TimelineLite()
      .to(this.$refs.conclusion, 1, { aframe: { alpha: 1 } })
      .set(this.$el, { aframe: { x: 0, y: 4, z: -30 }})
      .set(this.$el.object3D.rotation, { directionalRotation: { y: () => this.fixObject({ x: 0, y: 0, z: 50 }), useRadians: true }})
      .addLabel('descente')
      .to(this.$refs.conclusion, 1, { aframe: { alpha: 0 } })
      .to(this.$el, 30, { aframe: { z: this.defaultPos.z, x: this.defaultPos.x  }}, 'descente')
      .add([
        TweenLite.to(this.$el, 10, { delay: 4, aframe: { y: 2 }}),
        TweenLite.to(this.$el.object3D.rotation, 3, {
          delay: 10,
          directionalRotation: { y: () => {
            if(this.vr) return this.$el.object3D.rotation.y + '_short'
            const pos = this.fixObject(this.$obelix)
            return pos + '_short'
          }, useRadians: true },
        }),
        TweenLite.to(this.$el.object3D.rotation, 5, {
          delay: 15,
          directionalRotation: { y: () => {
            if(this.vr) return this.$el.object3D.rotation.y + '_short'
            const pos = this.fixObject({x: 0, y: 0, z: 50})
            return pos + '_short'
          }, useRadians: true },
        }),
        TweenLite.to(this.$el.object3D.rotation, 5, {
          delay: 20,
          directionalRotation: { y: () => {
            if(this.vr) return this.$el.object3D.rotation.y + '_short'
            const pos = this.fixObject({x: 0, y: 0, z: -50})
            return pos + '_short'
          }, useRadians: true },
        })
      ], 'descente').timeScale(.5)
    },
    fixObject(target) {
      if(!this.$refs.camera || !this.$el)
        return

      let cameraRotY = THREE.Math.radToDeg(this.$refs.camera.object3D.rotation.y)
      cameraRotY = (cameraRotY % 360 + 360) % 360
      target = new THREE.Vector3( target.x, target.y, target.z )
      const observer = this.$observer
      const cameraRot = new THREE.Euler().copy(this.$refs.camera.object3D.rotation)

      observer.rotation.order = 'YXZ'
      observer.position.copy(this.$el.object3D.position)
      observer.rotation.copy(cameraRot)
      const bk = new THREE.Euler().copy(observer.rotation)
      observer.lookAt(target)
      const finalRot = new THREE.Euler().copy(observer.rotation)
      finalRot.y += Math.PI
      observer.rotation.copy(bk)

      let y = THREE.Math.radToDeg(finalRot.y) - cameraRotY
      y = (y % 360 + 360) % 360

      let start = this.$el.object3D.rotation.y
      start = (start % 360 + 360) % 360

      return THREE.Math.degToRad(y)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/camera/Camera.vue